import { Component, inject, Input, NgModule, OnDestroy, OnInit } from '@angular/core'

import { IonicModule } from '@ionic/angular'
import { takeUntil, tap } from 'rxjs/operators'
import { Observable, Subject } from 'rxjs'
import { ModalController } from '@ionic/angular'
import { FormStatus } from '../../../../models/functional/formStatus'

@Component({
  selector: 'app-assistance-editor-save-popup',
  templateUrl: './assistance-editor-save-popup.component.html',
  styleUrls: ['./assistance-editor-save-popup.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class AssistanceEditorSavePopupComponent implements OnInit, OnDestroy {
  private modalCtrl = inject(ModalController)

  @Input() statusChanges$: Observable<FormStatus>

  private unsubscribe: Subject<void> = new Subject<void>()
  formStatus: FormStatus

  timeout

  ngOnInit(): void {
    this.statusChanges$
      .pipe(
        takeUntil(this.unsubscribe),
        tap((formStatus) => {
          clearTimeout(this.timeout)
          if (formStatus.isSaved()) {
            // start delay timer
            this.timeout = setTimeout(() => this.dismiss(), 200)
          }
        }),
      )
      .subscribe((sc) => {
        this.formStatus = sc
      })
  }

  ngOnDestroy(): void {
    this.unsubscribe.next()
    this.unsubscribe.complete()
  }

  private async dismiss() {
    try {
      await this.modalCtrl.dismiss({ success: true })
    } catch (e) {
      console.log('Unable to dismiss AssistanceEditorSavePopup', e)
    }
  }
}
